import { useSurfacePreference } from "../../../hooks/use-surface-preference.ts"
import {
  CALENDAR_WORKING_SCHEDULE_KEY,
  DEFAULT_WORKING_SCHEDULE,
  normalizeWorkingSchedule,
  type WorkingSchedule
} from "./working-schedule.ts"

/**
 * The signed-in user's own Calendar working schedule — persisted via the same
 * keyed UserUIPreferences bag Projects/Files/Albums already use for "a screen
 * remembers its choice" (see docs/kb/decisions/2026-08-31-a-surface-remembers-its-choice-by-key.md),
 * not the Calendar redux slice (which persists only `filters`).
 */
export const useWorkingSchedule = (): [
  WorkingSchedule,
  (value: WorkingSchedule) => void
] => {
  const [stored, setStored] = useSurfacePreference<WorkingSchedule>(
    CALENDAR_WORKING_SCHEDULE_KEY,
    DEFAULT_WORKING_SCHEDULE
  )

  return [normalizeWorkingSchedule(stored), setStored]
}
